"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_query_1 = require("@tanstack/react-query");
const dayjs_1 = __importDefault(require("dayjs"));
const classnames_1 = __importDefault(require("classnames"));
const bookingSlice_1 = require("../../../store/slices/bookingSlice");
const SpinnerOverlay_1 = __importDefault(require("../../../components/SpinnerOverlay/SpinnerOverlay"));
const store_1 = require("../../../store/store");
const axios_1 = __importDefault(require("axios"));
const TimeSelector = ({ appointment, bookingFlowType, }) => {
    const dispatch = (0, store_1.useAppDispatch)();
    const { calendarId, donationType, date: { selectedDate, selectedTime }, } = (0, store_1.useAppSelector)((state) => state.booking.currentBooking);
    const appSettings = (0, store_1.useAppSelector)((state) => state.app.appSettings);
    const { data: slotsResponse, isLoading } = (0, react_query_1.useQuery)({
        queryKey: ['bookable-slots', calendarId, donationType, selectedDate],
        queryFn: () => calendarId && donationType
            ? axios_1.default
                .post('/api/booking/get-bookable-slots', {
                calendarId,
                donationType,
                date: (0, dayjs_1.default)(selectedDate).format('YYYY-MM-DD'),
                existingAppointmentId: bookingFlowType === 'rebook' ? appointment === null || appointment === void 0 ? void 0 : appointment.appointmentId : undefined,
            })
                .then((response) => response.data.data)
            : undefined,
    });
    const handleSlotClick = (0, react_1.useCallback)((slot) => {
        dispatch((0, bookingSlice_1.setSelectedTime)(slot === null || slot === void 0 ? void 0 : slot.time));
        dispatch((0, bookingSlice_1.updateCurrentBooking)({ prop: 'slotId', value: slot === null || slot === void 0 ? void 0 : slot.id }));
        dispatch((0, bookingSlice_1.setStepIndex)(2));
    }, [dispatch]);
    const availableSlots = (0, react_1.useMemo)(() => slotsResponse === null || slotsResponse === void 0 ? void 0 : slotsResponse.map((row) => ((0, jsx_runtime_1.jsx)("div", { className: "row", children: row.slots.map((slot) => ((0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)('slot col col-3 d-flex justify-content-center align-items-center p-3 cursor-pointer', { active: selectedTime === slot.time }), onClick: () => handleSlotClick(slot), role: "button", tabIndex: 0, onKeyDown: (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    handleSlotClick(slot);
                }
            }, children: (0, jsx_runtime_1.jsx)("span", { children: slot.time }) }, slot.id))) }, row.heading))), [slotsResponse, selectedTime, handleSlotClick]);
    return ((0, jsx_runtime_1.jsx)("div", { id: "time-selector", className: "position-relative", children: (0, jsx_runtime_1.jsx)(SpinnerOverlay_1.default, { visible: isLoading, children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("h4", { className: "w-100 d-flex justify-content-center", children: (0, dayjs_1.default)(selectedDate).format(appSettings === null || appSettings === void 0 ? void 0 : appSettings.dateFormat) }), (0, jsx_runtime_1.jsx)("div", { className: "time-table container-fluid", children: availableSlots })] }) }) }));
};
exports.default = TimeSelector;
